import { MouseEvent, useCallback, useState } from 'react';
import { toast } from '#/components/UnifiedRfqs/toast';
import { useDrfqService } from '@paradigm/features/src/unified-rfqs/contexts/drfqs';
import { razzmatazz } from '@paradigm/design-system/src/colors';
import BoldCross from '@paradigm/design-system/src/assets/BoldCross';
import { useTrackAction } from '@paradigm/features/src/analytics';
import PillButton from '../components/PillButton';

interface Props {
  readonly orderId: string;
}
export default function KillOrderButton({ orderId }: Props) {
  const drfqService = useDrfqService();
  const [isLoading, setIsLoading] = useState(false);
  const trackAction = useTrackAction();

  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      trackAction('kill quote');
      setIsLoading(true);
      event.stopPropagation();
      drfqService
        .cancelOrder({ orderId })
        .then((resp) => {
          if (!resp.ok) {
            toast(resp.message);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [drfqService, orderId, trackAction],
  );

  return (
    <PillButton
      ariaLabel="Kill order"
      onClick={handleClick}
      icon={<BoldCross width={9} color={razzmatazz} />}
      iconPlacement="left"
      disabled={isLoading}
    >
      Kill
    </PillButton>
  );
}
